import { combineReducers } from "redux";
import { notificationReducer } from "../reducers/notificationReducer";
import { spinnerReducer } from "../reducers/spinnerReducer";
import { accountReducer } from "./accountReducer";
import { galleryReducer } from "./galleryReducer";
import { cartReducer } from "./cartReducer";
import { orderReducer } from "./orderReducer";
import { logisticaReducer } from "./logisticaReducer";

export default combineReducers({
    notification: notificationReducer,
    spinner: spinnerReducer,
    account: accountReducer,
    gallery: galleryReducer,
    cart: cartReducer,
    order: orderReducer,
    logistica: logisticaReducer
});